import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const PlayerCardComponent = ({ player }) => {
  const navigate = useNavigate();

  const getColorForValue = (value) => {
    if (value <= 30) return '#EF4444';     // Red
    if (value <= 70) return '#FBBF24';     // Yellow/Orange
    return '#10B981';                      // Green
  };

  const handleClick = () => {
    navigate(`/player/${player.id}`);
  };

  return (
    <div className="card" style={{ width: '280px' }}>
      {/* Player Info */}
      <div className="flex-row" style={{ alignItems: 'center' }}>
        <img
          src={player.photoURL || 'https://placehold.co/80x80?text=No+Photo'}
          alt="Player"
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            objectFit: 'cover'
          }}
        />
        <div style={{ marginLeft: '1rem' }}>
          <div style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{player.name}</div>
          <div className="text-muted">{player.position}</div>
          <div className="text-small">Shirt #{player.shirtNumber}</div>
        </div>
      </div>

      {/* Skills */}
      {player.skills?.length > 0 && (
        <ul className="mt-4" style={{ listStyle: 'none', padding: 0 }}>
          {player.skills.map((skill, index) => (
            <li
              key={index}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '0.25rem',
              }}
            >
              <span>{skill.name}</span>
              <span style={{ color: getColorForValue(skill.value), fontWeight: 600 }}>
                {skill.value}
              </span>
            </li>
          ))}
        </ul>
      )}

      {/* Details Button */}
      <button onClick={handleClick} className="btn-secondary mt-4" style={{ width: '100%' }}>
        View Player
      </button>
    </div>
  );
};

export default PlayerCardComponent;
